// AROMA COMPASS — UI strings (IT + EN)
// Oil names, keywords and synergy names RESTANO in italiano (identità del metodo).

export const STRINGS = {
  it: {
    locale: "IT",
    altLocale: "EN",
    toggleAria: "Cambia lingua",
    // Home
    homeBrand: "Aroma Compass",
    homeFooterTag: "IT · 2026",
    homeSubtitle: "La tua bussola aromatica",
    homeIntro:
      "Ci sono momenti in cui non abbiamo bisogno di altre risposte, ma di riconoscere la direzione verso cui qualcosa dentro di noi ci sta chiamando. Aroma Compass nasce per aiutarti ad ascoltare quel movimento attraverso il linguaggio degli oli essenziali.",
    homeCta: "Scopri la tua direzione",
    homeAuthor: "di Elisabetta Basetti Sani",
    homeShortTag: "5 domande · 2 oli · 1 rituale",
    // Quiz
    quizBack: "← Indietro",
    quizStepLabel: (step, total) => `${step} / ${total}`,
    // Result
    resultBrand: "Aroma Compass",
    resultRestartShort: "↻ Rifai",
    resultLead: "La tua bussola oggi indica…",
    resultInterpretationLabel: "Interpretazione",
    resultRitualLabel: "Il tuo rituale",
    resultIntentionLabel: "Frase · Intenzione",
    resultSave: "Salva il risultato",
    resultSaving: "Preparazione…",
    resultShare: "Condividi",
    resultRestart: "Rifai il percorso",
    resultCtaTitle: "Vuoi andare più a fondo?",
    resultCtaBody:
      "Aroma Compass ti mostra una direzione. Una consulenza personalizzata permette di esplorare ciò che emerge in modo più completo.",
    resultCtaButton: "Scopri le consulenze",
    resultWhatsapp: "Preferisci scrivermi direttamente?",
    resultWhatsappLink: "Contattami su WhatsApp",
    resultAuthor: "di Elisabetta Basetti Sani",
    toastSaveOk: "Bussola salvata sul dispositivo",
    toastSaveErr: "Non è stato possibile salvare l'immagine",
    toastShareOk: "Condivisione avviata",
    toastShareErr: "Condivisione non disponibile su questo dispositivo",
    // Newsletter
    nlEyebrow: "Rituali stagionali",
    nlTitle: "Vuoi ricevere rituali stagionali?",
    nlBody: "Lascia la tua mail: nessuno spam, solo le mie riflessioni, quando arrivano.",
    nlEmailPlaceholder: "La tua email",
    nlConsent:
      "Acconsento a ricevere email da Aroma Compass. Posso disiscrivermi in qualsiasi momento.",
    nlSubmit: "Lascio la mia mail",
    nlSubmitting: "Un momento…",
    nlThanksTitle: "Grazie di cuore.",
    nlThanksBody:
      "Ti scriverò con delicatezza, solo quando ci sarà qualcosa di significativo da condividere.",
    nlErrConsent: "Serve il tuo consenso esplicito per iscriverti",
    nlErrEmail: "Inserisci un indirizzo email valido",
    nlErrGeneric: "Non è stato possibile completare l'iscrizione",
    nlOkSubscribed: "Iscrizione registrata, grazie",
    nlOkAlready: "Sei già iscritta — grazie",
    // Share card
    cardLead: "La tua bussola oggi indica…",
    cardIntentionLabel: "Frase · Intenzione",
    cardAuthor: "di Elisabetta Basetti Sani",
  },
  en: {
    locale: "EN",
    altLocale: "IT",
    toggleAria: "Change language",
    // Home
    homeBrand: "Aroma Compass",
    homeFooterTag: "EN · 2026",
    homeSubtitle: "Your aromatic compass",
    homeIntro:
      "There are moments when we don't need more answers, but to recognize the direction something within us is calling us toward. Aroma Compass is here to help you listen to that movement through the language of essential oils.",
    homeCta: "Find your direction",
    homeAuthor: "by Elisabetta Basetti Sani",
    homeShortTag: "5 questions · 2 oils · 1 ritual",
    // Quiz
    quizBack: "← Back",
    quizStepLabel: (step, total) => `${step} / ${total}`,
    // Result
    resultBrand: "Aroma Compass",
    resultRestartShort: "↻ Retake",
    resultLead: "Your compass today points to…",
    resultInterpretationLabel: "Interpretation",
    resultRitualLabel: "Your ritual",
    resultIntentionLabel: "Phrase · Intention",
    resultSave: "Save your result",
    resultSaving: "Preparing…",
    resultShare: "Share",
    resultRestart: "Retake the quiz",
    resultCtaTitle: "Want to go deeper?",
    resultCtaBody:
      "Aroma Compass shows you a direction. A personalized consultation allows you to explore what emerges in a more complete way.",
    resultCtaButton: "Discover consultations",
    resultWhatsapp: "Prefer to write to me directly?",
    resultWhatsappLink: "Contact me on WhatsApp",
    resultAuthor: "by Elisabetta Basetti Sani",
    toastSaveOk: "Compass saved to your device",
    toastSaveErr: "Couldn't save the image",
    toastShareOk: "Sharing started",
    toastShareErr: "Sharing isn't available on this device",
    // Newsletter
    nlEyebrow: "Seasonal rituals",
    nlTitle: "Would you like to receive seasonal rituals?",
    nlBody:
      "Leave your email: no spam, only my reflections, when they arrive.",
    nlEmailPlaceholder: "Your email",
    nlConsent:
      "I agree to receive emails from Aroma Compass. I can unsubscribe at any time.",
    nlSubmit: "Submit",
    nlSubmitting: "One moment…",
    nlThanksTitle: "Thank you, truly.",
    nlThanksBody:
      "I will write to you gently, only when there is something meaningful to share.",
    nlErrConsent: "Your explicit consent is required to subscribe",
    nlErrEmail: "Enter a valid email address",
    nlErrGeneric: "We couldn't complete your subscription",
    nlOkSubscribed: "Subscription registered, thank you",
    nlOkAlready: "You're already subscribed — thank you",
    // Share card
    cardLead: "Your compass today points to…",
    cardIntentionLabel: "Phrase · Intention",
    cardAuthor: "by Elisabetta Basetti Sani",
  },
};

export function pickLang(lang) {
  return STRINGS[lang] || STRINGS.it;
}
